// extracted by mini-css-extract-plugin
export default {"login":"FormOverlay_login__dF9n2","profile":"FormOverlay_profile__c43CL FormOverlay_login__dF9n2"};